if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const {
        InspectorControls,
        InspectorAdvancedControls,
        InnerBlocks
    } = window.wp.editor;
    
    const { 
        TextControl,
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/section-title', {
        // built-in attributes
        title: 'Section Title',
        description: 'Section Title',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            anchor: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                anchor,
            } = attributes;

            const ALLOWED_BLOCKS = [
                'core/heading',
                'core/separator',
                'core/paragraph',
                'core/image',
                'core/button',
                'core/buttons',
                'custom-gutenberg/button'
            ];

            const TEMPLATE = [
                [ 'core/heading', { 
                    level: 2, 
                    placeholder: 'Title', 
                    className: 'section-title' 
                } ],
                ['core/paragraph', { 
                    placeholder: 'Description',
                    className: 'section-description'
                }],
            ];

            // custom functions
            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                    </InspectorControls>
                    <InspectorAdvancedControls>
                        <TextControl
                            __nextHasNoMarginBottom
                            __next40pxDefaultSize
                            label="HTML anchor"
                            value={ anchor }
                            onChange={ ( anchor ) => {
                                setAttributes( {
                                    anchor: anchor,
                                } );
                            } }
                            />
                    </InspectorAdvancedControls>
                </Fragment>,
                <div id={ anchor } className="section-title">
                    <div className="container" style={{ color: 'dark' }}>
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ TEMPLATE } templateLock="false" />
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {
            const {
                anchor,
            } = attributes;
            return (
                <div id={ anchor } className="section-title">
                    <div className="section-content">
                        <InnerBlocks.Content />
                    </div> 
                </div>
            );
        },
    });
}